import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: ${(props) => props.theme.colors?.text || "#111827"};
  margin: 0;
`;

export const MappingGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const MappingRow = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 16px;
  align-items: center;
`;

export const MappingLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: ${(props) => props.theme.colors?.text || "#111827"};

  span.required {
    color: ${(props) => props.theme.colors?.error || "#DC2626"};
  }
`;

export const ArrowIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.theme.colors?.textSecondary || "#6B7280"};

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const SelectWrapper = styled.div`
  width: 100%;

  select {
    width: 100%;
    padding: 10px 12px;
    font-size: 14px;
    border: 1px solid ${(props) => props.theme.colors?.border || "#E5E7EB"};
    border-radius: 8px;
    background: ${(props) => props.theme.colors?.background || "#FFFFFF"};
    color: ${(props) => props.theme.colors?.text || "#111827"};
    cursor: pointer;
    transition: border-color 0.2s ease;

    &:focus {
      outline: none;
      border-color: ${(props) => props.theme.colors?.primary || "#3B82F6"};
    }

    &:disabled {
      background: ${(props) => props.theme.colors?.backgroundSecondary || "#F3F4F6"};
      cursor: not-allowed;
    }
  }
`;

export const ColumnHeaders = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid ${(props) => props.theme.colors?.border || "#E5E7EB"};
  margin-bottom: 4px;
`;

export const ColumnHeader = styled.span`
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: ${(props) => props.theme.colors?.textSecondary || "#6B7280"};
`;

export const ValidationMessage = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  border-radius: 8px;
  background: ${(props) => 
    props.$type === "error" 
      ? props.theme.colors?.errorLight || "#FEE2E2"
      : props.theme.colors?.warningLight || "#FEF3C7"
  };
  color: ${(props) => 
    props.$type === "error"
      ? props.theme.colors?.error || "#DC2626"
      : props.theme.colors?.warning || "#D97706"
  };
  font-size: 14px;

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 16px;
`;

export const AutoMappedBanner = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  border-radius: 8px;
  background: ${(props) => props.theme.colors?.successLight || "#D1FAE5"};
  color: ${(props) => props.theme.colors?.success || "#059669"};
  font-size: 14px;

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const SampleValue = styled.span`
  display: block;
  font-size: 12px;
  color: ${(props) => props.theme.colors?.textSecondary || "#6B7280"};
  margin-top: 4px;
  font-style: italic;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 200px;
`;

export const SelectWithSample = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PreviewSection = styled.div`
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid ${(props) => props.theme.colors?.border || "#E5E7EB"};
`;

export const PreviewHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const PreviewTitle = styled.h4`
  font-size: 14px;
  font-weight: 600;
  color: ${(props) => props.theme.colors?.text || "#111827"};
  margin: 0;
`;

export const PreviewBadge = styled.span`
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 12px;
  background: ${(props) => props.theme.colors?.primaryLight || "#EFF6FF"};
  color: ${(props) => props.theme.colors?.primary || "#3B82F6"};
`;

export const PreviewTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  border: 1px solid ${(props) => props.theme.colors?.border || "#E5E7EB"};
  border-radius: 8px;
  overflow: hidden;
  font-size: 13px;

  th, td {
    padding: 10px 12px;
    text-align: left;
    border-bottom: 1px solid ${(props) => props.theme.colors?.border || "#E5E7EB"};
  }

  th {
    background: ${(props) => props.theme.colors?.backgroundSecondary || "#F9FAFB"};
    font-weight: 600;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: ${(props) => props.theme.colors?.textSecondary || "#6B7280"};
  }

  td {
    color: ${(props) => props.theme.colors?.text || "#111827"};
  }

  tr:last-child td {
    border-bottom: none;
  }

  tr:hover td {
    background: ${(props) => props.theme.colors?.backgroundSecondary || "#F9FAFB"};
  }
`;

export const RowNumber = styled.td`
  width: 40px;
  text-align: center !important;
  color: ${(props) => props.theme.colors?.textSecondary || "#9CA3AF"} !important;
  font-weight: 500;
`;

export const EmptyCell = styled.span`
  color: ${(props) => props.theme.colors?.textSecondary || "#9CA3AF"};
  font-style: italic;
`;
